import { cn } from '@/utils/ui/styles'

type TableToolbarProps = {
	children: React.ReactNode
	className?: string
}

/**
 * Container layout for table toolbar elements
 *
 * Provides standard flex layout with responsive behavior.
 * Children typically include TableSearch, TableFilters, TableLastUpdated.
 *
 * @example
 * <TableToolbar>
 *   <div className="flex gap-2">
 *     <TableFilters options={filterOptions} />
 *     <TableSearch placeholder="Search..." />
 *   </div>
 *   <TableLastUpdated dataUpdatedAt={query.dataUpdatedAt} refetch={query.refetch} />
 * </TableToolbar>
 */
export function TableToolbar({ children, className }: TableToolbarProps) {
	return (
		<div
			className={cn(
				'flex w-full flex-col items-end justify-between gap-4 md:flex-row md:items-center',
				className,
			)}
		>
			{children}
		</div>
	)
}
